import { render, staticRenderFns } from "./ExportWizardFlags.vue?vue&type=template&id=61f07f1a"
import script from "./ExportWizardFlags.vue?vue&type=script&lang=js"
export * from "./ExportWizardFlags.vue?vue&type=script&lang=js"
import style0 from "./ExportWizardFlags.vue?vue&type=style&index=0&id=61f07f1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports